import { createSearchHook } from "./createSearchHook";

const [useSearchItems, searchItems] = createSearchHook("searchItems", "items");

export default useSearchItems;
export { searchItems };
